<template>
  <div v-if="shares && shares.length" class="home-banners">
    <h3 class="title">Советы по использованию</h3>
    <div class="container">
      <div class="home-banners__list">
        <div class="home-banners__item" v-for="(item, i) in shares" :key="i">
          <SlideComponent :data="item" is-share />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SlideComponent from "./SlideComponent.vue";

export default {
  name: "RecommendationsComponent",
  props: {
    shares: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  components: { SlideComponent },
};
</script>

<style lang="stylus">
@import "~@/styles/mixins/ratio.styl"
.home-banners {
  &__list {
    padding 0 30px
    display flex
    flex-wrap wrap
    gap 30px
    background: var(--white)
    border-radius: calc(var(--main_radius) * 2)
    +below(840px) {
      //padding 0 30px
      border-radius 0
      gap 20px
    }
    +below(720px) {
      flex-wrap nowrap
      overflow-x auto
    }
  }

  &__item {
    border-radius: var(--main_radius);
    overflow: hidden;
    width calc(33.333333% - 20px)
    +below(840px) {
      width calc(33.333333% - 14px)
    }
    +below(720px) {
      width 90%
      flex-shrink 0
    }

    .main-slide {
      ratio(393, 350)
      height 100%
      +below(720px) {
        ratio(605, 350)
      }
    }

    //&:nth-child(-n+2) {
    //  width calc(50% - 15px)
    //  +below(840px) {
    //    width calc(50% - 10px)
    //  }
    //  +below(720px) {
    //    width 90%
    //    flex-shrink 0
    //  }
    //
    //  .main-slide {
    //    ratio(605, 350)
    //    height 100%
    //  }
    //}
  }
}
</style>
